<template>
    <div id="footer">
        <ul>
            <li>
                <router-link :to="{ name: 'impressum' }">{{$t('Global.Footer01')}}</router-link>
            </li>
            <li>
              <router-link :to="{ name: 'datenschutz' }">{{$t('Global.Footer02')}}</router-link>
            </li>
            <!--<li>
              <router-link :to="{ name: 'agb' }">AGB</router-link>
            </li> -->
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
        },
    };
</script>
<style scoped lang="scss">

     #footer{
         width: auto;
        display: inline-flex;
        align-self: flex-end;
        ul{
            display: flex;
            padding: 15px 20px;
            background-color: #c9cac8;
            list-style: none;
            margin-bottom: 0px;
            li{
                margin: 0px 10px;
                a{
                    color: black;
                    &:hover{
                        color: #FF3547;
                    }
                }
            }
        }
     }


</style>
